import moment from "moment";
import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import { Button, Col, Image, Modal, Row } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import Alert from "react-s-alert";
import { PopupInsideButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import { Toggle } from "../../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";

// import OrderDescModelBody from "../../SuperAdminOrders/SuperAdminOrdersTable/OrderDescModelBody";
// import EditOrder from "../../SuperAdminOrders/SuperAdminOrdersTable/EditOrder";
// import OrderLocation from "../../SuperAdminOrders/SuperAdminOrdersTable/OrderLocation";
// import SubstituteModal from "../../SuperAdminOrders/SuperAdminOrdersTable/SubstituteModal";
// import SendSmsNew from "../../../reusableComponents/allPopupReusable/SendSmsNew";
import NotificationsNew from "../../../reusableComponents/allPopupReusable/NotificationsNew";
// import LocationReusable from "../../../../../components/reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
// import { PopupIconButtonReusable } from "../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import { Select, TextField, FormControl, IconButton } from "@material-ui/core";
import { Form } from "react-bootstrap";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import en from "react-phone-number-input/locale/en.json";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
// import OrderRequest from "../../../../vendorDashboardComponents/Orders/OrderRequest/OrderRequest";
// import AddOrder from "../../../../vendorDashboardComponents/Orders/OrderDashboard/AddOrder";
// import CustomisationEditModel from "../../../../vendorDashboardComponents/Orders/OrderRequest/CustomisationEditModel";

import { NavLink } from "react-router-dom";

import store from "../../../../store/store";
import {
  SET_VENDOR_ORDERING_CART_DATA,
  UPDATE_CART_FILTERED_MENU_ORDER,
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  CREATE_ORDER_VENDOR,
  FILTERED_MENU_ORDER,
  SELECTED_SUBSTITUTE_ITEM,
  SUBSTITUTE_EXISTING_RECORDS,
  SET_VENDOR_ORDERING_EDIT_DATA,
  ADD_NEW_SELECTED_ITEM,
  ADD_NEW_EXISTING_RECORDS,
} from "../../../../store/types";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  cancel_item_order,
  debit_memo_order_cancel_item,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import {
  get_menu_items_by_passing_item_id_in_array,
  update_item_menu_setup_without_loader,
  get_category_menu_setup,
} from "../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import NewCountDown from "../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import CallingButtonPopup from "../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import AddItem from "../../../superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminOrdersTable/AddItem";
import {
  calcFinalTotalEdit,
  calcTotalOriginalEdit,
} from "../../../../function/ordering";
import { NEW_PAYMENT_TYPE } from "../../../../enums/OrderEnums";

// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     minWidth: "100%",
//   },
//   selectEmpty: {
//     marginTop: theme.spacing(2),
//   },
// }));

const EditOrder = (props) => {
  const dispatch = useDispatch();
  //Model order view
  const [MrDetail, setMrDetail] = useState({ MrDetail: false });
  const [orderEditData, setOrderEditData] = useState(props?.orderDetails);
  const viewOrderInDetail = () => setMrDetail({ MrDetail: !MrDetail.MrDetail });
  const [dataLoader, setDataLoader] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [singleItemData, setSingleItemData] = useState({
    id: 0,
    qty: 0,
    index: 0,
  });

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(
      token,
      (data) => {
        setDataLoader(false);
      },
      true
    );
  }, []);

  useEffect(() => {
    if (props?.orderDetails !== undefined && props?.orderDetails !== null) {
      store.dispatch({
        type: SET_VENDOR_ORDERING_CART_DATA,
        payload: props?.orderDetails,
      });
    }
  }, [props?.orderDetails]);

  useEffect(() => {
    if (props?.cartData !== undefined && props?.cartData !== null) {
      store.dispatch({
        type: SET_VENDOR_ORDERING_CART_DATA,
        payload: props?.cartData,
      });
    }
  }, [props?.cartData]);

  /****************************************
   * @DESC Item Remove Confirmation Popup
   ****************************************/
  const onCloseConfirm = () => {
    setOpenConfirm(false);
  };
  const onOpenConfirm = (itemId, quantity, index) => {
    setOpenConfirm(true);
    setSingleItemData({
      ...singleItemData,
      id: itemId,
      qty: quantity,
      index: index,
    });
  };
  const yesButtonAction = () => {
    const itemData = singleItemData;
    onMinusItemQty(itemData.id, itemData.qty, itemData.index);
    setOpenConfirm(false);
  };

  const [vtype, viewType] = useState(3);
  const [orderSelected, setOrderSelected] = useState("take_away");
  let filteredMenuData = [];

  useEffect(() => {
    if (props.orderDetails.order_type === 0) {
      setOrderSelected("take_away");
    } else if (props.orderDetails.order_type === 1) {
      setOrderSelected("curb_side");
    } else if (props.orderDetails.order_type === 2) {
      setOrderSelected("skip_line");
    } else if (props.orderDetails.order_type === 3) {
      setOrderSelected("dine_in");
    }

    for (let i = 0; i < props.menuCategory.length; i++) {
      let tempCategory = JSON.parse(JSON.stringify(props.menuCategory[i]));
      tempCategory.items = [];
      //tempCategory.items.filteredItems = [];
      for (let j = 0; j < props.menuCategory[i].items.length; j++) {
        if (
          props.menuCategory[i].items[j][orderSelected].value &&
          props.menuCategory[i].items[j].status
        ) {
          let dataToSend = JSON.parse(
            JSON.stringify(props.menuCategory[i].items[j])
          );
          dataToSend[orderSelected].sizes = [];
          dataToSend.cartLength = 0;
          for (
            let m = 0;
            m < props.menuCategory[i].items[j][orderSelected].sizes.length;
            m++
          ) {
            if (
              props.menuCategory[i].items[j][orderSelected].sizes[m].available
            ) {
              dataToSend[orderSelected].sizes.push(
                props.menuCategory[i].items[j][orderSelected].sizes[m]
              );
            }
          }
          tempCategory.items.push(dataToSend);
        }
      }
      if (tempCategory.items.length > 0) {
        filteredMenuData.push(tempCategory);
      }
      tempCategory = {};
    }
    dispatch({ type: FILTERED_MENU_ORDER, payload: filteredMenuData });
  }, [props.orderDetails]);

  const [cookLevels, setCookLevels] = useState({
    spice: 4,
    sugar: 4,
    salt: 5,
    fat: 5,
    meat: 5,
    egg: 5,
  });

  const createdAt = new Date(props.orderDetails.createdAt);
  const updatedTime = moment(
    props?.orderDetails?.max_time_date || props?.orderDetails?.OrderAcceptTime
  ).add(parseInt(props.orderDetails?.max_time), "minutes");
  let diff = updatedTime.diff(moment());
  const seatedTime = new Date(props.orderDetails.OrderAcceptTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference() {
    let StartedTime = new Date(props.orderDetails.OrderAcceptTime).getTime();
    let EndedTime = new Date(props.orderDetails.OrderCompleteTime).getTime();
    let difference = EndedTime - StartedTime;
    let hourss = Math.floor(difference / 3.6e6);
    let minutess = Math.floor((difference % 3.6e6) / 6e4);
    return hourss + " hh : " + minutess + " mins";
  }

  const calcTaxes = (data) => {
    let tax = Object.values(data).reduce(
      (a, b) => parseFloat(a || 0) + parseFloat(b || 0),
      0
    );

    return tax.toFixed(2);
  };

  const prepareLevels = (data) => {
    let levelNames = [];
    if (data.spice_level) {
      let spice = "Spice : " + data.spice_level.level + "/" + cookLevels.spice;
      levelNames.push(spice);
    }
    if (data.salt_level) {
      let salt = "Salt : " + data.salt_level.level + "/" + cookLevels.salt;
      levelNames.push(salt);
    }
    if (data.sugar_level) {
      let sugar = "Sugar : " + data.sugar_level.level + "/" + cookLevels.sugar;
      levelNames.push(sugar);
    }
    if (data.fat_level) {
      let fat =
        "fat/oil/fried : " + data.fat_level.level + "/" + cookLevels.fat;
      levelNames.push(fat);
    }
    if (data.meat_cook_level) {
      let meat = "Meat : " + data.meat_cook_level.level + "/" + cookLevels.meat;
      levelNames.push(meat);
    }
    if (data.egg_cook_level) {
      let egg = "Egg : " + data.egg_cook_level.level + "/" + cookLevels.egg;
      levelNames.push(egg);
    }
    return levelNames.toString();
  };

  const prepData = () => {
    const formData = {};
    if (
      props.orderDetails &&
      props.orderDetails.user_location &&
      props.orderDetails.user_location.lat
    ) {
      formData.track_location = {};
      formData.track_location.latitude = props.orderDetails.user_location.lat;
      formData.track_location.longitude = props.orderDetails.user_location.long;
    }
    formData.user_details = props.orderDetails.user_details;
    formData.user_details.name =
      props.orderDetails.user_details.first_name +
      " " +
      props.orderDetails.user_details.last_name;
    formData.diner_id = props.orderDetails.order_id;
    formData.type = "ordering";
    return formData;
  };

  const getAddOns = (data) => {
    let addOnsNames = [];
    if (data && data[0] && data[0].options) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].options.length; j++) {
          addOnsNames.push(data[i].options[j].name);
        }
      }
    } else {
      for (let i = 0; i < data.length; i++) {
        addOnsNames.push(data[i].name);
      }
    }
    return addOnsNames.toString();
  };

  const [showCancel, setShowCancel] = useState(false);
  const [orderId, setOrderId] = useState();
  const [itemIndex, setItemIndex] = useState();

  const [memoOpen, setMemoOpen] = useState(false);

  const handleCloseCancel = () => {
    setShowCancel(false);
  };

  const onCloseMemo = () => {
    setMemoOpen(false);
  };

  const onClickCancelOrder = (idOrder) => {
    setOrderId(idOrder);
    setShowCancel(true);
  };

  const handleClickNo = () => {
    setShowCancel(false);
  };

  const handleClickYes = () => {
    const formData = { order_status: 8, id: orderId };
    props.onUpdateOrderStatus(formData);
    setShowCancel(false);
  };

  const onClickChangeStatusAlert = () => {
    Alert.error(
      `<h4>You can't perform this action because order put on hold</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  const onClickChangeStatus = (orderStatus, id, orderType) => {
    var formData = {};
    if (orderType === 3 && orderStatus === 4) {
      // check for dine in order
      formData = { order_status: orderStatus + 2, id: id };
    } else if (orderType === 0 && orderStatus === 4) {
      // check for dine in order
      formData = { order_status: orderStatus + 2, id: id };
    } else {
      formData = { order_status: orderStatus + 1, id: id };
    }
    if (orderStatus + 1 === 1) {
      formData.OrderAcceptTime = new Date().getTime();
    }
    if (orderType === 3 && orderStatus === 6) {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    } else {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    }
    if (orderStatus === 8) {
      formData = { order_status: 0, id: id };
      // formData.OrderAcceptTime = new Date().getTime();
    }

    props.onUpdateOrderStatus(formData);
  };

  const onClickResetReject = (orderStatus, id, orderType) => {
    let prepData = {};
    if (orderStatus === 0) {
      prepData = {
        order_status: 8,
        id: id,
        // OrderAcceptTime: new Date().getTime(),
        // OrderCompleteTime: new Date().getTime(),
        max_time: 0,
      };
    } else if (orderStatus === 6 && orderType === 3) {
      prepData = { order_status: orderStatus - 2, id: id };
    } else if (orderStatus === 6 && orderType === 0) {
      prepData = { order_status: orderStatus - 2, id: id };
    } else if (orderStatus === 8) {
      prepData = {
        order_status: 0,
        id: id,
        OrderAcceptTime: new Date().getTime(),
        OrderCompleteTime: new Date().getTime(),
        max_time: 0,
      };
    } else {
      prepData = { order_status: orderStatus - 1, id: id };
    }

    props.onUpdateOrderStatus(prepData);
  };

  const [showHoldOrder, setShowHoldOrder] = useState(false);
  const [itemValue, setItemValue] = useState(1);

  useEffect(
    (e) => {
      let value =
        props.orderDetails &&
        props.orderDetails.order_items.map((item1, index) => item1.quantity);
      let amount =
        props.orderDetails &&
        props.orderDetails.order_items.map(
          (item1, index) => item1?.size?.price
        );
      setItemValue(value);
      setItemAmount(amount);
    },
    [props.orderDetails.order_items]
  );

  const handleCloseHoldOrder = () => {
    setShowHoldOrder(false);
  };

  const onClickHoldOrder = () => {
    const formData = { onhold: true, id: props.orderDetails._id };
    props.onUpdateOrderStatus(formData);
  };

  const onChangeHold = (holdStatus, id) => {
    if (holdStatus) {
      const formData = { onhold: !holdStatus, id: id };
      props.onUpdateOrderStatus(formData);
    } else {
      setShowHoldOrder(true);
    }
  };

  const [showSubstitute, setShowSubstitute] = useState(false);
  const handleCloseSubstitute = () => {
    setShowSubstitute(false);
  };

  const onClickShowSubstituteModal = (itemData, id, index) => {
    setShowSubstitute(true);
    setSubstituteItemData(itemData);
    setOrderId(id);
    setItemIndex(index);
  };

  const calcDate = () => {
    return props.orderDetails?.later_date || props.orderDetails?.createdAt;
  };

  const calcItemsLength = () => {
    let count = 0;
    for (let i = 0; i < props.orderDetails.order_items.length; i++) {
      if (
        props.orderDetails.order_items[i].isSubstituted ||
        props.orderDetails.order_items[i].isCancelled
      ) {
      } else {
        count += 1;
      }
    }
    return count;
  };

  const showSubstituteedItemText = () => {
    let data = "";
    for (let i = 0; i < props.orderDetails.order_items.length; i++) {
      if (props.orderDetails.order_items[i].isSubstituted) {
        data = "Substituted Item";
      }
    }
    return data;
  };

  // const onSuccess = (memoId) => {
  //   // console.log(itemIndex);
  //   // console.log(orderId);
  //   // console.log(props.orderDetails.order_items);

  //   const existingData = { ...props.orderDetails };
  //   const itemToCheck = existingData.order_items[itemIndex];
  //   itemToCheck.isCancelled = true;
  //   //let finalPriceIncluingTaxes = 0;
  //   //let taxesToDeduct = 0;
  //   let addOns = 0;
  //   let priceInCludingAddons = 0;
  //   for (let i = 0; i < itemToCheck.addOns.length; i++) {
  //     for (let j = 0; j < itemToCheck.addOns[i].options.length; j++) {
  //       addOns += parseInt(itemToCheck.addOns[i].options[j].price);
  //     }
  //   }
  //   priceInCludingAddons +=
  //     (itemToCheck.size.price + addOns) * itemToCheck.quantity;
  //   existingData.base_amount = existingData.base_amount - priceInCludingAddons;
  //   let taxesCode = {};
  //   for (let i = 0; i < itemToCheck.sur_charges.length; i++) {
  //     if (itemToCheck.sur_charges[i].flag === "PERCENTAGE") {
  //       //taxesCode[itemToCheck.sur_charges[i].code]+=
  //       let calPer =
  //         (priceInCludingAddons * itemToCheck.sur_charges[i].value) / 100;
  //       taxesCode[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] = calPer;
  //       existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] = parseFloat(
  //         existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //         ] - calPer
  //       ).toFixed(2);
  //       existingData.total_amount = existingData.total_amount - calPer;
  //     } else {
  //       taxesCode[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] = (itemToCheck.sur_charges[i].value * itemToCheck.quantity);
  //       existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] =
  //         existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //         ] - (itemToCheck.sur_charges[i].value * itemToCheck.quantity);
  //       existingData.total_amount =
  //         existingData.total_amount - (itemToCheck.sur_charges[i].value * itemToCheck.quantity);
  //     }
  //   }

  //   existingData.total_amount = parseFloat(
  //     existingData.total_amount - priceInCludingAddons
  //   ).toFixed(2);
  //   const formData = {};
  //   formData.order_id = orderId;
  //   if (existingData.payment_method === 0) {
  //   } else {
  //     formData.memoId = memoId;
  //   }
  //   formData.order_items = existingData.order_items;
  //   formData.total_amount = existingData.total_amount;
  //   formData.base_amount = existingData.base_amount;
  //   formData.gstAmount = existingData.gstAmount;
  //   const token = props.auth.user.accessToken;

  //   let cancelledCount = 0;
  //   for (let i = 0; i < formData.order_items.length; i++) {
  //     if (formData.order_items[i].isCancelled || formData.order_items[i].isSubstituted) {
  //       cancelledCount += 1;
  //     }
  //   }
  //   if (cancelledCount === formData.order_items.length) {
  //     formData.order_status = 8;
  //     formData.total_amount = 0;
  //     formData.base_amount = 0;
  //     formData.gstAmount = {};
  //   }
  //   props.cancel_item_order(token, formData, onSuccessfinal);
  // };

  const onSuccess = (memoId) => {
    try {
      const existingData = { ...props.orderDetails };
      const itemToCheck = existingData.order_items[itemIndex];
      itemToCheck.isCancelled = true;
      let newOrderData = existingData.order_items.filter(
        (ele, i) => !((ele.isSubstituted || ele.isCancelled) && itemIndex !== i)
      );
      const formData = {};
      formData.order_items = existingData.order_items;
      let orderData = calcFinalTotalEdit(
        formData.order_items,
        props.orderDetails,
        props.subscription
      );
      formData.total_amount = orderData.total;
      formData.base_amount = calcTotalOriginalEdit(formData.order_items);
      let taxesArr = [];
      formData.gstAmount = orderData.taxes.gst;
      formData.surCharges = orderData.taxes.surCharges;
      formData.order_id = existingData._id;
      const token = props?.auth?.user.accessToken;
      let cancelledCount = 0;
      for (let i = 0; i < formData.order_items.length; i++) {
        if (
          formData.order_items[i].isCancelled ||
          formData.order_items[i].isSubstituted
        ) {
          cancelledCount += 1;
        }
      }
      if (cancelledCount === formData.order_items.length) {
        formData.order_status = 8;
        formData.total_amount = 0;
        formData.base_amount = 0;
        formData.gstAmount = {};
      }
      props.cancel_item_order(token, formData, onSuccessfinal);
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const onSuccessfinal = () => {};

  const handleClickConfirm = () => {
    if (subType === "Substitute") {
      viewType(5);
      viewOrderInDetail();
      handleCloseSubstitute();
      let orderSelected = "";
      if (props.orderDetails.order_type === 0) {
        orderSelected = "take_away";
      } else if (props.orderDetails.order_type === 1) {
        orderSelected = "curb_side";
      } else if (props.orderDetails.order_type === 2) {
        orderSelected = "skip_line";
      } else if (props.orderDetails.order_type === 3) {
        orderSelected = "dine_in";
      } else if (props.orderDetails.order_type === 7) {
        orderSelected = "home_delivery";
      }
      let existingData = JSON.parse(JSON.stringify(props.orderDetails));
      existingData.orderSelected = orderSelected;
      existingData.selectedTabId = 1;

      // dispatch({
      //   type: SELECTED_SUBSTITUTE_ITEM,
      //   payload: substituteItemData,
      // });
      dispatch({ type: CREATE_ORDER_VENDOR, payload: existingData });
    } else {
      // console.log(orderId);
      // console.log(substituteItemData);

      if (props.orderDetails.payment_method !== 0) {
        let addOnsTotal = 0;
        for (let i = 0; i < substituteItemData.addOns.length; i++) {
          for (
            let j = 0;
            j < substituteItemData.addOns[i].options.length;
            j++
          ) {
            addOnsTotal += parseInt(
              substituteItemData.addOns[i].options[j].price
            );
          }
        }
        let taxes = 0;
        let tempTotal = substituteItemData.size.price + addOnsTotal;
        for (let i = 0; i < substituteItemData.sur_charges.length; i++) {
          if (substituteItemData.sur_charges[i].flag === "PERCENTAGE") {
            taxes +=
              parseFloat(tempTotal * substituteItemData.sur_charges[i].value) /
              100;
          } else {
            taxes += tempTotal + substituteItemData.sur_charges[i].value;
          }
        }

        let amount = tempTotal;

        const formData = {};
        formData.amount = (amount + taxes) * substituteItemData.quantity;
        formData.order_id = orderId;
        formData.items = [];
        formData.items.push(substituteItemData);
        formData.items[0].isCancelled = true;

        const token = props.auth.user.accessToken;
        props.debit_memo_order_cancel_item(token, formData, onSuccess);
      } else {
        onSuccess();
      }
    }
  };
  const [state, setState] = useState({
    code: props.auth.user.VendorUser.country_code,
  });
  // const [itemValue, setItemValue] = useState();

  const onChange = (e) => {
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    setState({
      ...state,
      [e.target.name]: newData,
    });
  };

  const history = useHistory();
  const [subType, setSubType] = useState("Substitute");
  const [substituteItemData, setSubstituteItemData] = useState({});
  const [itemsId, setItemsId] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [selectedItemArray, setSelectedArray] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [activeItemData, setActiveItemData] = useState();
  const [itemAmount, setItemAmount] = useState(0);
  const onClickNext = () => {
    if (itemCount === itemsId.length) {
      //redirect to subtitute
      // console.log(selectedItemArray);
      let prepareSubstituteData = [];
      for (let i = 0; i < props.orderDetails.order_items.length; i++) {
        if (selectedItemArray.includes(props.orderDetails.order_items[i]._id)) {
          prepareSubstituteData.push(props.orderDetails.order_items[i]);
        }
      }
      //alert("time to redirect ");
      dispatch({
        type: SELECTED_SUBSTITUTE_ITEM,
        payload: prepareSubstituteData,
      });
      //props.orderDetails.selectedTabId = 1;
      dispatch({
        type: SUBSTITUTE_EXISTING_RECORDS,
        payload: props.orderDetails,
      });

      history.push("/substituteitem");
    } else {
      setActiveItemData(itemsData[itemCount - 1 + 1]);
      setItemCount(itemCount + 1);
    }
  };

  const onSuccessItems = (data, items, itemsArr) => {
    setItemsData(data);
    setActiveItemData(data[0]);
    setItemsId(items); // this items to update
    setSelectedArray(itemsArr); // this is substitute id
    setItemCount(1); // determine how many we need to show popup show only item
    viewType(6);
  };
  const updateSelectedArray = (itemsArr) => {
    if (itemsArr.length === 0) {
      Alert.error(`<h4>Please select atleast one item to substitute</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      let items = [];
      for (let i = 0; i < props.orderDetails.order_items.length; i++) {
        if (itemsArr.includes(props.orderDetails.order_items[i]._id)) {
          if (!items.includes(props.orderDetails.order_items[i].item.id)) {
            items.push(props.orderDetails.order_items[i].item.id);
          }
        }
      }

      const token = props.auth.user.accessToken;
      const formData = {
        item_id: items,
      };
      props.get_menu_items_by_passing_item_id_in_array(
        token,
        formData,
        onSuccessItems,
        items,
        itemsArr
      );
      //viewType(6);
    }
  };

  const onSuccessUpdateLocalData = (data) => {
    let updateExistingData = { ...activeItemData };
    updateExistingData.status = data.status;
    setActiveItemData(updateExistingData);
  };

  const changeStatus = (status, id) => {
    const formData = {};
    if (status === undefined) {
      formData.status = false;
    } else {
      formData.status = !status;
    }
    const token = props.auth.user.accessToken;
    props.update_item_menu_setup_without_loader(
      id,
      formData,
      token,
      onSuccessUpdateLocalData
    );
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onAddItemQty = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(props?.cart_data));
    cartData[0][index].quantity = qty + 1;
    cartData[0][index].finalPrice =
      cartData[0][index].size.price * cartData[0][index].quantity;
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });
    // let addOnsNames = [];
    // if (data && data[0] && data[0].options) {
    //   for (let i = 0; i < data.length; i++) {
    //     for (let j = 0; j < data[i].options.length; j++) {
    //       addOnsNames.push(data[i].options[j].name);
    //     }
    //   }
    // } else {
    //   for (let i = 0; i < data.length; i++) {
    //     addOnsNames.push(data[i].name);
    //   }
    // }
    // return addOnsNames.toString();
    // let globalQty = 0;
    // for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
    //   for (
    //     let j = 0;
    //     j < this.props.vendor_filtered_menu[i].items.length;
    //     j++
    //   ) {
    //     if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
    //       globalQty =
    //         this.props.vendor_filtered_menu[i].items[j].cartLength + 1;
    //       break;
    //     }
    //   }
    // }

    // const formData = {};
    // formData.cartLength = globalQty;
    // formData.id = itemId;
    // store.dispatch({
    //   type: UPDATE_CART_FILTERED_MENU_ORDER,
    //   payload: formData,
    // });
  };

  const onMinusItemQty = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(props?.cart_data));
    if (cartData[0][index].quantity - 1 === 0) {
      cartData[0].splice(index, 1);
    } else {
      cartData[0][index].quantity = qty - 1;
      cartData[0][index].finalPrice =
        cartData[0][index].size.price * cartData[0][index].quantity;
    }
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });

    //   let globalQty = 0;
    //   for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
    //     for (
    //       let j = 0;
    //       j < this.props.vendor_filtered_menu[i].items.length;
    //       j++
    //     ) {
    //       if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
    //         globalQty =
    //           this.props.vendor_filtered_menu[i].items[j].cartLength - 1;
    //         break;
    //       }
    //     }
    //   }
    //   const formData = {};
    //   formData.cartLength = globalQty;
    //   formData.id = itemId;
    //   store.dispatch({
    //     type: UPDATE_CART_FILTERED_MENU_ORDER,
    //     payload: formData,
    //   });
  };

  const onClickProcedModel = () => {
    let newFinalPrice = 0;
    let oldDataTotalAmountArr = [];
    let newOldTotalItemPrice = 0;
    let cartData = JSON.parse(JSON.stringify(props?.cart_data));
    let orderOldData = JSON.parse(JSON.stringify(orderEditData));
    for (let i = 0; i < orderOldData.order_items.length; i++) {
      oldDataTotalAmountArr.push(
        orderOldData.order_items[i].size.price *
          orderOldData.order_items[i].quantity
      );
    }
    newOldTotalItemPrice = oldDataTotalAmountArr.reduce(function (acc, val) {
      return acc + val;
    }, 0);
    let newPrice = [];
    for (let i = 0; i < cartData[0].length; i++) {
      newPrice.push(cartData[0][i].size.price * cartData[0][i].quantity);
    }
    newFinalPrice = newPrice.reduce(function (acc, val) {
      return acc + val;
    }, 0);
    newFinalPrice = newFinalPrice - newOldTotalItemPrice;
    orderOldData.editItemPrice = newFinalPrice;
    setOrderEditData(orderOldData);
    setMemoOpen(true);
  };

  const onSubmitEditData = () => {
    // /repayment
    store.dispatch({
      type: SET_VENDOR_ORDERING_EDIT_DATA,
      payload: orderEditData,
    });
    history.push("/repayment");
  };

  const [_state, _setState] = useState({
    open: false,
  });

  const onOpenModal = () => {
    _setState({
      open: true,
    });
  };

  const onCloseModal = () => {
    _setState({
      open: false,
    });
  };

  const onClickAddNewItem = () => {
    let prepareAddNewItemData = [];
    let orderSelected = "";
    if (props.orderDetails.order_type === 0) {
      orderSelected = "take_away";
    } else if (props.orderDetails.order_type === 1) {
      orderSelected = "curb_side";
    } else if (props.orderDetails.order_type === 2) {
      orderSelected = "skip_line";
    } else if (props.orderDetails.order_type === 3) {
      orderSelected = "dine_in";
    } else if (props.orderDetails.order_type === 7) {
      orderSelected = "home_delivery";
    }
    let existingData = JSON.parse(JSON.stringify(props.orderDetails));
    existingData.orderSelected = orderSelected;
    existingData.selectedTabId = 1;
    dispatch({ type: CREATE_ORDER_VENDOR, payload: existingData });

    for (let i = 0; i < props.orderDetails.order_items.length; i++) {
      if (selectedItemArray.includes(props.orderDetails.order_items[i]._id)) {
        prepareAddNewItemData.push(props.orderDetails.order_items[i]);
      }
    }
    dispatch({
      type: ADD_NEW_SELECTED_ITEM,
      payload: prepareAddNewItemData,
    });
    dispatch({
      type: ADD_NEW_EXISTING_RECORDS,
      payload: props.orderDetails,
    });
    history.push("/addnewedititems");
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3 action_icon_padding"
        onClick={(e) => onOpenModal()}
      >
        <Image
          src={require("../../../../assets/images/superadmin/ordericon/Edit.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </Button>{" "}
      <Modal
        show={_state.open}
        onClose={(e) => onCloseModal()}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "offer-event-main closeRemove min-height-100vh w-100",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="d-flex align-items-center py-3 px-4 border-bottom">
          <span className="pr-3 cursor" onClick={(e) => onCloseModal()}>
            <Image
              alt="Back"
              width="20px"
              src={require("../../../../assets/images/UserManagement/backIcon.svg")}
            />
          </span>
          <div className="f12-400 c_black">Edit Order Details</div>
        </div>
        <div className="superadmin-orderscomponent-main">
          {/* <div className="container-fluid" style={{ marginBottom: "2%" }}>
            <Row>
              <Col md={6}>
                <h5>Order Name: Alexander Petersburg</h5>
              </Col>
              <Col md={6}>
                <h5>
                  Order Type:{" "}
                  <span className="badge badge-warning">Take Away</span>
                </h5>
              </Col>
            </Row>
          </div> */}

          <div
            className="model-head-view-order-detailed "
            style={{
              border: "1px solid #E0E0E0",
              padding: "1%",
              borderRadius: "5px 0px 0px 5px",
            }}
          >
            <div
              style={{
                borderRadius: "5px",
                borderLeft: "5px solid #37ac1e",
                paddingLeft: "1%",
              }}
            >
              <div className="model-view-order-detailed-table">
                <div className="d-flex">
                  <div className="col-2 f12-500 opacity5 p-0">Order Type</div>
                  <div className="col-3 f12-500 opacity5 p-0">
                    Name &<br /> Request No.
                  </div>
                  <div className="col-2 f12-500 opacity5 p-0">No. Items</div>
                  <div className="col-3 f12-500 opacity5 p-0">
                    Amount / Payment
                  </div>
                  <div className="col-2 f12-500 opacity5 p-0">
                    Ordeing Preference
                  </div>
                </div>
                <div style={{ marginTop: "1%" }}>
                  <div className="d-flex model-view-order-detailed-table">
                    <div className="col-2 p-0">
                      <img
                        src={
                          props.orderDetails &&
                          props.orderDetails.order_type === 0
                            ? require("../../../../assets/images/superadmin/ordericon/takeaway.svg")
                            : props.orderDetails &&
                              props.orderDetails.order_type === 1
                            ? require("../../../../assets/images/superadmin/ordericon/curb side.svg")
                            : props.orderDetails &&
                              props.orderDetails.order_type === 3
                            ? require("../../../../assets/images/superadmin/ordericon/dine in.svg")
                            : props.orderDetails &&
                              props.orderDetails.order_type === 2
                            ? require("../../../../assets/images/superadmin/ordericon/skip the line.svg")
                            : ""
                        }
                        width="35px"
                        alt={
                          props.orderDetails &&
                          props.orderDetails.order_type === 0
                            ? "takeaway"
                            : props.orderDetails &&
                              props.orderDetails.order_type === 1
                            ? "curb side"
                            : props.orderDetails &&
                              props.orderDetails.order_type === 3
                            ? "dine in"
                            : ""
                        }
                      />
                      {/* <img
                        src={require("../../../../assets/images/superadmin/ordericon/takeaway.svg")}
                        width="35px"
                        alt="Takeaway"
                      /> */}
                    </div>
                    <div className="col-3 p-0 f12-500">
                      {props.orderDetails &&
                      props.orderDetails.user_details &&
                      props.orderDetails.user_details.first_name &&
                      props.orderDetails.user_details.last_name
                        ? props.orderDetails.user_details.first_name +
                          " " +
                          props.orderDetails.user_details.last_name
                        : ""}
                      <p style={{ fontSize: ".75rem" }} className="f10-400">
                        #{props.orderDetails && props.orderDetails.order_id}
                      </p>
                    </div>

                    <div className="col-2 p-0 f12-500">
                      {calcItemsLength(props.orderDetails)}
                    </div>
                    <div className="col-3 p-0 f12-500">
                      <i className="fa fa-inr mr-1" aria-hidden="true"></i>
                      {props.orderDetails?.total_amount !== null &&
                      props.orderDetails?.total_amount !== undefined
                        ? props.orderDetails.total_amount.toFixed(2)
                        : ""}
                      <br />
                      <span>
                        {props &&
                        props.orderDetails &&
                        props.orderDetails.payment_status === 1 ? (
                          <span className="badge badge-success"> PAID</span>
                        ) : props &&
                          props.orderDetails &&
                          props.orderDetails.payment_status === 0 ? (
                          <span className="badge badge-danger"> UNPAID</span>
                        ) : props.orderDetails.payment_status === 3 ? (
                          <span className="badge badge-danger"> FAILURE</span>
                        ) : (
                          "N/A"
                        )}
                      </span>
                      <br />
                      <span className="f12-500">
                        {/* {props.orderDetails &&
                          props.orderDetails.payment_method === 0
                          ? "COD"
                          : props.orderDetails.payment_method === 1
                            ? "UPI"
                            : props.orderDetails.payment_method === 2
                              ? "Paytm"
                              : props.orderDetails.payment_method === 3
                                ? "Debit Card"
                                : props.orderDetails.payment_method === 4
                                  ? "Credit Card"
                                  : props.orderDetails.payment_method === 5
                                    ? "NetBanking"
                                    : props.orderDetails.payment_method === 6
                                      ? "Pay Later"
                                      : props.orderDetails.payment_method === 7
                                        ? "Wallet"
                                        : props.orderDetails.payment_method === 8
                                          ? "External Wallet"
                                          : props.orderDetails.payment_method === 9
                                            ? "Cash"
                                            : null} */}
                        {props?.orderDetails?.splitPayment ? (
                          <>Split Payment</>
                        ) : (
                          NEW_PAYMENT_TYPE[props?.orderDetails?.payment_method]
                        )}
                      </span>
                    </div>
                    <div className="col-2 p-0 f12-500">
                      {props.orderDetails &&
                      props.orderDetails.order_type === 1 ? (
                        <Fragment>
                          <div>
                            {/* {console.log(props.orderDetails)} */}
                            <p className="f12-500 mb-2">
                              {props.orderDetails &&
                                props.orderDetails?.curb_side_details?.number}
                            </p>
                            <p className="f9-500 opacity5">
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details.model}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details.make}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details
                                  .vehical_type_value}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details
                                  .vehical_type}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details.year}
                            </p>
                            <div
                              className="mt-1"
                              style={{
                                width: "15px",
                                height: "15px",
                                borderRadius: "50%",
                                backgroundColor: `${
                                  props.orderDetails &&
                                  props.orderDetails.curb_side_details &&
                                  props.orderDetails.curb_side_details.color
                                }`,
                                boxShadow: "0px 4px 8px #00000029",
                              }}
                            ></div>
                          </div>
                        </Fragment>
                      ) : (
                        <Fragment>
                          {(props.orderDetails &&
                            props.orderDetails.order_type === 3) ||
                          (props.orderDetails &&
                            props.orderDetails.order_type === 2)
                            ? props?.orderDetails?.dine_in_details?.table_number
                            : "N/A"}
                        </Fragment>
                      )}
                    </div>
                    {/* <div className="col-3 f12-500"></div> */}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 d-flex p-0">
              <div className="col-4" style={{ maxWidth: "fit-content" }}>
                <div className="f12-500 opacity5 mb-2">
                  Req. Date /Time/Timer
                </div>
                <h6 className="timer-count" style={{ color: "#EE3A23" }}>
                  {/* {(props.orderDetails &&
                              props.orderDetails.order_status === 7) ||
                            (props.orderDetails &&
                              props.orderDetails.order_status === 8) ? (
                              <></>
                            ) : props.orderDetails &&
                              props.orderDetails.order_status === 0 ? (
                              "00:00:00"
                            ) : ( */}
                  <NewCountDown waitNew={diff} />
                  {/* )} */}

                  {/* {(props.orderDetails &&
                              props.orderDetails.order_status === 7) ||
                            (props.orderDetails &&
                              props.orderDetails.order_status === 8) ? (
                              <> </>
                            ) : props.orderDetails && props.orderDetails.order_status === 0 ? "" : "" : (
                              <NewCountDown waitNew={diff} />
                            )} */}
                </h6>
              </div>
              <div className="col-4" style={{ maxWidth: "100%" }}>
                <div className="f12-500" style={{ color: "#2196F3" }}></div>
                <div>
                  <p className="f12-500">
                    {moment(calcDate()).format("Do MMMM YYYY")}
                    <br />
                    {moment(calcDate()).format("hh : mm A")}
                  </p>
                </div>
              </div>
              <div className="col-4">
                <div className="f12-500" style={{ color: "#2196F3" }}>
                  Track User
                </div>
                <div>
                  <img
                    src={require("../../../../assets/images/superadmin/ordericon/location_red.svg")}
                    width="25px"
                    alt="location"
                  />
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 d-flex align-items-center p-0">
              <div className="col-8 d-flex p-0">
                <CallingButtonPopup 
                sendData={props.orderDetails} 
                displayButton={"OrderMain"}/>
                <Button
                  variant="link"
                  className="enIconBtn mr-3 action_icon_padding"
                  // onClick={() => {
                  // viewType(1);
                  // viewOrderInDetail();
                  // }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/eye.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button>{" "}
                {/* <Button
                  variant="link"
                  className="enIconBtn mr-3 action_icon_padding"
                  // onClick={() => {
                  // viewType(2);
                  // viewOrderInDetail();
                  // }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                    style={{ margin: "8px" }}
                  />
                </Button>{" "} */}
                <NotificationsNew
                  // order_id={props.orderDetails._id}
                  // dataSend={props.orderDetails}
                  style={{ minWidth: "25px" }}
                />
                <ChatWindow
                  // data={props.orderDetails}
                  text={"order"}
                  style={{ minWidth: "25px" }}
                />
              </div>
              <div className="col-4">
                <p style={{ fontSize: ".75rem" }}>Total wait time</p>
                <div className="row">
                  <div
                    //   className="col-5"
                    style={
                      {
                        // background: "#F0F0F0 0% 0% no-repeat padding-box",
                        // borderRadius: "6px",
                      }
                    }
                  >
                    <button
                      className="btn btn-secondary w-100"
                      style={{
                        fontSize: ".5rem",
                        background: "#F0F0F0 0% 0% no-repeat padding-box",
                        borderRadius: "6px",
                        color: "#000000",
                      }}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/hourglass.svg")}
                        width="15px"
                        alt="Hour glass"
                      />
                      {/* {props?.orderDetails &&
                      props?.orderDetails?.order_status === 7 ? ( */}
                      {/* <>{seated_time_difference(minutesSeated)}</> */}
                      <>{props.seated_time_difference}</>
                      {/* ) : (
                        <>00 HH : 00 min</>
                      )} */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 d-flex">
              <div className="col-7">
                <div className="f12-500 opacity5">Order Notes</div>
                <div className="f12-500">
                  {props.orderDetails && props.orderDetails.notes}
                </div>
              </div>
              <div className="col-5">
                <div className="f12-500 opacity5">ETC</div>
                <div className="f12-500">
                  {props.orderDetails &&
                    props.orderDetails.order_items.map((item, index) => (
                      <Fragment key={index}>
                        {!item.isSubstituted ? (
                          <>
                            {/* <div className="f9-400"> */}
                            {item && item.item && item.item.prepTime} min
                            {/* </div> */}
                          </>
                        ) : (
                          <></>
                        )}
                      </Fragment>
                    ))}
                </div>
              </div>
            </div>
            <br />
            <div className="col-12 seating-dashboard-table">
              <div className="f12-700">Edit Details</div>
            </div>
            <div class="row">
              <div className="col-md-3 col-lg-3 col-sm-4 col-4">
                <Form.Group
                  // className="reusableInputComponent-main mb-0 form-control"
                  controlId={"code"}
                >
                  <div className="input-phone-country-code-reusable w-100">
                    <select
                      name="code"
                      value={state.code}
                      onChange={onChange}
                      className="w-100"
                    >
                      <option value={state.code}>{state.code}</option>
                      {getCountries().map((country) => (
                        <option
                          key={country}
                          value={"+" + getCountryCallingCode(country)}
                        >
                          {en[country]} (+{getCountryCallingCode(country)})
                        </option>
                      ))}
                    </select>
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-6 col-xs-7 col-8">
                <Form.Group>
                  <NewInputText
                    controlClass={"mobile_number"}
                    placeHolder="Mobile Number"
                    type="number"
                    labelText="Phone Number"
                    variant="outlined"
                    extraClass={`w-100 mb-1`}
                    onInput={maxLengthCheck}
                    maxLength={10}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={props?.orderDetails?.user_details?.mobile_number}
                    name="mobile_number"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <TextField
                  id="first_name"
                  label="First Name"
                  variant="outlined"
                  className={`w-100`}
                  name="first_name"
                  value={props?.orderDetails?.user_details?.first_name}
                />
              </div>
              <div className="col-6">
                <TextField
                  id="last_name"
                  label="Last Name"
                  variant="outlined"
                  className={`w-100`}
                  name="last_name"
                  value={props?.orderDetails?.user_details?.last_name}
                />
              </div>
            </div>
            <hr />
            <div className="col-12">
              <h6>Items Added</h6>
            </div>
            <br />
            <div className="col-12">
              {!isEmpty(props && props?.cart_data && props?.cart_data[0]) &&
                props &&
                props?.cart_data &&
                props?.cart_data[0].map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <AddItem
                        // orderDetails={props?.orderDetails}
                        index={index}
                        item={item}
                        vendor_filtered_menu={props.vendor_filtered_menu}
                        orderSelected={orderSelected}
                        dataLoader={dataLoader}
                        onClickAddQty={() =>
                          onAddItemQty(item._id, item.quantity, index)
                        }
                        onClickMinusQty={
                          item.quantity <= 1
                            ? () =>
                                onOpenConfirm(item._id, item.quantity, index)
                            : () =>
                                onMinusItemQty(item._id, item.quantity, index)
                        }
                      />
                    </React.Fragment>
                  );
                })}
              {/* <div className="col-3">
                <Image
                  src={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-01.png")}
                  alt="non veg"
                  title="non veg"
                  width="55px"
                  height="55px"
                  fluid
                />
                {"  "}
              </div>
              <div className="col-6">
                <Image
                  src={require("../../../../assets/images/superadmin/ordericon/non veg.svg")}
                  alt="non veg"
                  title="non veg"
                  width="20px"
                  fluid
                />
                {"  "}
                Chicken Biryani <br />
                Almond, Cassis
              </div>
              <div className="col-3">
                <div className="d-flex" align="center">
                  <img
                    src={require("../../../../assets/images/superadmin/ordericon/add.svg")}
                    width="30px"
                    alt="Add"
                  />
                  1
                  <img
                    src={require("../../../../assets/images/superadmin/ordericon/less.svg")}
                    width="30px"
                    alt="Less"
                  />
                </div>
              </div> */}
            </div>
            <hr />
            <div className="col-12">
              <button
                className="btn bordered-button-primary"
                onClick={() => onClickAddNewItem()}
              >
                Add Another Item
              </button>
            </div>
            <div className="col-12">
              {/* <div className="f16-500 pt-3 pb-2">Special Ocassion</div> */}
              <br />
              {/* <div className="col-12"> */}

              <TextField
                variant="outlined"
                fullWidth
                label="Name"
                multiline
                rows={3}
                value={props?.orderDetails?.notes}
              />
              {/* </div> */}
            </div>
          </div>
          <div className="d-flex align-items-center p-2 justify-content-center">
            <Button
              variant="outline-secondary"
              className="mr-4 px-5 py-2"
              onClick={(e) => onCloseModal()}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="px-5  py-2"
              onClick={() => onClickProcedModel()}
              type="button"
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
      <Modal show={memoOpen} size="md" onHide={onCloseMemo} centered>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Create Memo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f12-500 opacity5">
            Please Create the debit memo for the substituted Item
          </div>
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
              onClick={() => {
                setMemoOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
              // to="/repayment"
              onClick={() => onSubmitEditData()}
            >
              Proceed
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showHoldOrder} onHide={handleCloseHoldOrder} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to put this order on hold ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseHoldOrder}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={handleCloseBlockUser}
            onClick={() => onClickHoldOrder()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/*  () =>onOpenConfirm */}
      <Modal show={openConfirm} size="md" onHide={onCloseConfirm} centered>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Remove Item
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f12-500 opacity5">
            Are you sure you want to remove this item?
          </div>
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel"
              onClick={onCloseConfirm}
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Yes"
              onClick={yesButtonAction}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

EditOrder.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  servicesEnabled:
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering,
  allOrderDataa: state.vendorOrdering.vendor_get_all_takeaway_order,
  onboarding: state.onboarding.restaurantDetails,
  vendor_filtered_menu: state.vendorOrdering.vendor_filtered_menu,
  menuCategory: state.onboarding.menuCategory,
  cart_data: state.vendorOrdering.vendor_cart_data,
  subscription: state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  cancel_item_order,
  debit_memo_order_cancel_item,
  get_menu_items_by_passing_item_id_in_array,
  update_item_menu_setup_without_loader,
  get_category_menu_setup,
})(EditOrder);

// export default EditOrder;
